/**
 * AssetStatusService
 * Service for AssetStatus lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetStatus CRUD operations */
export class AssetStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetStatusService.DEFAULT_SERVICE_PATH,
            basePath: AssetStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetStatusService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetStatusService.BASE_PATH = 'api/asset-statuses';
//# sourceMappingURL=AssetStatusService.js.map